import React, { useState, useContext, useEffect } from 'react'

import AlertContext from '../../../../product/context/alert/alertContext'

import NetSuiteContext from '../../../../product/context/thirdParty/netsuite/netSuiteContext'

const CustomHeadAlert = () => {
    const alertContext = useContext(AlertContext)
    const netSuiteContext = useContext(NetSuiteContext)
    const { setAlert } = alertContext
    const {
        responseStatus: responseStatusNetSuite,
        clearResponse: clearResponseNetSuite,
    } = netSuiteContext

    useEffect(() => {
        if (responseStatusNetSuite) {
            if (!responseStatusNetSuite.noAlert) {
                setAlert(
                    responseStatusNetSuite.message,
                    responseStatusNetSuite.status
                )
            }
            clearResponseNetSuite()
        }
    }, [responseStatusNetSuite])

    return <></>
}
export default CustomHeadAlert
